module.exports = __webpack_public_path__ + "img/logo-bprs.a1979ad3.png";